// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G_OZE{display:flex;flex-direction:column;border:1px solid transparent;border-radius:16px;background-color:var(--bg-standard, #f3f5ff);color:var(--text-on-standard-bg, var(--text-standard, #282863));--text-standard: var(--text-on-standard-bg, var(--text-standard, #282863));--text-secondary: var(--text-on-standard-bg-secondary, var(--text-secondary, #696992));--text-standard-light: var(--text-on-standard-bg-secondary, var(--text-standard-light, #d4d4e0));transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out,opacity .2s ease-in-out;cursor:pointer;width:100%;height:100%}.G_OZE:hover:not(.YS_yb):not(.R31iZ){border-color:var(--button-outline-on-secondary, var(--button-primary, #6942f8))}.G_OZE:focus-visible{outline:2px solid var(--button-outline-on-secondary, var(--button-primary, #6942f8));outline-offset:2px}.G_OZE.YS_yb{border-color:var(--button-outline-on-secondary, var(--button-primary, #6942f8));cursor:default}.G_OZE.R31iZ{opacity:.5;cursor:not-allowed;pointer-events:none}.kGhDE{display:flex;flex-direction:column;flex:1;min-height:0;overflow:hidden}.Xf094{text-align:left;padding:20px 20px 16px 20px;flex-shrink:0}.nuc63{display:flex;flex-direction:column;gap:16px;padding:0 20px;flex:1;min-height:0;overflow-y:auto}.Fpa3V{padding:16px 20px 20px;margin-top:auto;justify-content:center;flex-shrink:0}._R5lm{width:100%;border-radius:8px;border:2px solid var(--button-outline-on-secondary, var(--text-button-on-secondary-bg, var(--button-primary, #6942f8)));background:var(--bg-standard, #f3f5ff) !important;color:var(--text-button-on-secondary-bg, var(--button-primary, #6942f8)) !important}._R5lm:hover:not([disabled]):not(:active){background:var(--button-primary-dark, #4520cc) !important;border-color:var(--button-primary-dark, #4520cc);color:var(--button-text-on-filled, #fcfcfd) !important}._R5lm:active{background:var(--button-primary-light, #8768f9) !important;border-color:var(--button-primary-light, #8768f9);color:var(--button-text-on-filled, #fcfcfd) !important}.DEVol{align-items:center;justify-content:center;gap:8px;width:100%;border-radius:8px;background:transparent;color:var(--text-button-on-secondary-bg, var(--button-primary, #6942f8));padding:8px 16px}.DEVol svg{color:var(--text-button-on-secondary-bg, var(--button-primary, #6942f8))}.vFkGN{color:var(--text-button-on-secondary-bg, var(--button-primary, #6942f8)) !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"packageCard": `G_OZE`,
	"selected": `YS_yb`,
	"disabled": `R31iZ`,
	"cardContent": `kGhDE`,
	"packageName": `Xf094`,
	"sectionsContainer": `nuc63`,
	"bottomArea": `Fpa3V`,
	"selectButton": `_R5lm`,
	"selectedIndicator": `DEVol`,
	"selectedLabel": `vFkGN`
};
export default ___CSS_LOADER_EXPORT___;
